/* eslint-disable eqeqeq */
import moment from 'moment'
import { getCookie } from './CookieHelper'
import moneta from '../../tasks_icons_android/moneta.png'
import { getUrlParameter } from './UrlHelperAndroid'
export const AppsType = {
    android: "android",
    rustore: "rustore",
    ios: "ios",
}
export const getAppUrl = (type_os, bundle) => {
    var url = ""
    if (type_os == AppsType.android){
        url = AppsUrls.android + bundle
    } else if (type_os == AppsType.rustore){
        url = AppsUrls.rustore + bundle
    } else {
        url = AppsUrls.ios + bundle
    }
    return url
}
export const getAndroidVersion = () => {
    var ua = (navigator.userAgent).toLowerCase(); 
    var match = ua.match(/android\s([0-9\.]*)/i);
    return match ? match[1] : undefined;
}
export const getIsDesktop = () => {
    return window.innerWidth >= 960 && !getIsAndroidApp()
}
export const shitPhoneLowScreen = () => {
    return window.innerWidth <= 340
}
export const getIsAndroidApp = () => {
    // typeof-проверка корректно отличает наличие нативного моста (раньше тут было
    // сравнение со строкой "undefined", что работало лишь из-за последующих проверок на null).
    return (typeof window.Android !== "undefined" && window.Android !== null)
}

export const getIsIosApp = () => {
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1 || ua.indexOf("ipod") > -1 || getCookie("platform") == "ios";
}
export const getIsAndroid = () => {
    
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("android") > -1;
}
export const getSmoozieMultiplier = () => {
    return getCookie("api_key") == "AppOffers" ? 1 : 25
}
// Сумма для показа: не больше 2 знаков после запятой и без лишних нулей
// (3.0864 → 3.09, 1.7500000000000002 → 1.75, 28 → 28)
export const formatMoney = (value) => {
    const n = Number(value)
    if (!isFinite(n)) return '0'
    return String(Math.round((n + (n >= 0 ? Number.EPSILON : -Number.EPSILON)) * 100) / 100)
}
// Рубли → валюта приложения (🍊/💎, у AppOffers — рубли), тоже не больше 2 знаков
export const toAppMoney = (rubles) => formatMoney((Number(rubles) || 0) * getSmoozieMultiplier())
export const getMoneyType = (isUpmob) => {
    // return getCookie("api_key") == "AppOffers" ? <img style={{width : "16px", height : "16px"}} src={moneta}/> : isUpmob ? " 💎" : "🍊"
    return getCookie("api_key") == "AppOffers" ? "₽" : isUpmob ? " 💎" : "🍊"
    // return  "🍊"
}
export const isShowBackBtn = () => {
    // «Чаты»: список — вкладка нижнего меню, открытая переписка (?dialog=) — экран со стрелкой «назад»
    const isChatsList = window.location.pathname.includes(Pages.chats) && !getUrlParameter("dialog")
    return (window.location.pathname == "" || window.location.pathname == "/" || window.location.pathname.includes(Pages.tasks) || window.location.pathname.includes(Pages.active) || window.location.pathname.includes(Pages.finished) || window.location.pathname.includes(Pages.profile) || window.location.pathname.includes(Pages.more) || window.location.pathname.includes(Pages.need_rework) || isChatsList)
}
export const isShowBottomMenu = () => {
    const isShow = !getIsDesktop() && isShowBackBtn() && !getUrlParameter("file_upload")

    // console.log("isShowBottomMenu = ", isShow)
    // console.log("isShowBottomMenu window.location.pathname = ", window.location.pathname)
    return isShow
}
export const setDateTitles = (tasks) => {
    var prevDate = ""
    tasks.forEach(element => {
        var date = moment(element.modified).utc().local().format("DD MMMM YYYY")
        var create_date = moment(element.modified).utc().local()
        // if (create_date.date() == moment().date()){
        //     date = "Сегодня"
        // }
        // if (create_date.date() == moment().add(1,'days').date()){
        //     date = "Завтра"
        // }
        // if (create_date.date() == moment().add(-1,'days').date()){
        //     date = "Вчера"
        // }
        if (create_date.dayOfYear() ===  moment().dayOfYear() && create_date.year() == moment().year()){
            date = "Сегодня"
        }
        const tomorrow = moment().add(1,'days')
        if (create_date.dayOfYear() ===  tomorrow.dayOfYear() && create_date.year() == tomorrow.year()){
            date = "Завтра"
        }
        const yesterday = moment().add(-1,'days')
        if (create_date.dayOfYear() ===  yesterday.dayOfYear() && create_date.year() == yesterday.year()){
            date = "Вчера"
        }
        if (prevDate != date){
            prevDate = date
            element.dateTitle = date
        }
    })
    return tasks
}
export const getSearchRequestAppUrl = (type_os, bundle, search_request) => {
    var url = ""
    if (type_os == AppsType.android){
        url = AppsSearchUrls.android + search_request + '&c=apps&hl=ru'
    } else if (type_os == AppsType.rustore){
        url = AppsSearchUrls.rustore + search_request
    } else {
        if (window.innerWidth >= 769) {
            url = AppsUrls.ios + bundle
        } else {
            url = AppsSearchUrls.ios + search_request
        }
    }
    return url
}
export const convertNeedReworkOrders = (orders) => {
        var mOrders = []
        orders.forEach(order => {
            order.progressArray = order.progress_orders[0].progressArray
            order.progressArraySDK = order.progress_orders[0].progressArraySDK
            order.opened_dates = order.progress_orders[0].opened_dates
            // дни возврата считаются от установки этим исполнителем (без этого — от последней установки заказа кем угодно)
            order.install_day = order.progress_orders[0].install_day
            order.last_open_retention_day = order.progress_orders[0].last_open_retention_day
            order.price_one_install_employer = order.progress_orders[0].price_one_install_employer

            order.category = "Активно"
            mOrders.push(order)
        });
        return mOrders
    }
export const AppsUrls = {
    android : "https://play.google.com/store/apps/details?id=",
    rustore : "https://www.rustore.ru/catalog/app/",
    ios : "https://itunes.apple.com/ru/app/id"
}
export const AppsSearchUrls = {
    android : "https://play.google.com/store/search?q=",
    rustore : "https://www.rustore.ru/catalog/search?query=",
    ios : "https://search.itunes.apple.com/WebObjects/MZSearch.woa/wa/search?media=software&term="
}

export const TasksTypes = {
    new_tasks : 'new',
    active_tasks : 'active',
}
export const Pages = {
    tasks : 'tasks',
    auth : 'auth',
    task : 'task',
    task_garanted_review : 'task_garanted_review',
    active : 'active',
    finished : 'finished',
    referals : 'referals',
    payouts : 'payouts',
    payout : 'payout',
    support : 'support',
    auth_insta : 'auth_insta',
    earn_insta : 'earn_insta',
    tiktok_task : 'tiktok_task',
    custom_task : 'custom_task',
    profile : 'profile',
    need_rework : 'need_rework',
    more : 'more',
    task_ios : 'task_ios',
    file_upload : 'file_upload',
    review_shot : 'review_shot',
    chats : 'chats',
    rating : 'rating',
    lottery : 'lottery',
}
export const Panels = {
    tasks_panel : "tasks_panel",
    task_panel : "task_panel",
    active_panel : "active_panel",
    finished_panel : "finished_panel",
    referals_panel : "referals_panel",
    payouts_panel : "payouts_panel",
    payout_panel : "payout_panel",
    support_panel : "support_panel",
    auth_insta_panel : "auth_insta_panel",
    earn_insta_panel : "earn_insta_panel",
    tiktok_task_panel : "tiktok_task_panel",
    custom_task_panel : "custom_task_panel",
 
}